import store from '@/store';

const user = store.state.user.user;

// 过滤人员数据 留下组织架构数据
export const getDepartmentOptions = () => {
    const structure = JSON.parse(JSON.stringify(store.state.noticeStaffData));

    const list = [];

    structure[0].children.forEach((item) => {
        // if (user.firstLevelDepartment === item.structureName) return;

        if (String(item.id).indexOf("P") === -1 && item.structureName) {
            list.push({
                label: item.structureName,
                value: item.structureName,
            });
        }
    });
    return list;
}
